import EventHandler from '../../utils/dom/event-handler';
import SelectorEngine from '../../utils/dom/selector-engine';
import Request, { ApiMode } from '../../utils/request';
import Manipulator from '../../utils/dom/manipulator';
import { startLoadingAnimation, stopLoadingAnimation } from '../../utils/dom/loading';

const CLASS_WRAPPER = 'p-activator-portal-training-page';
const CLASS_ENROLL_CARD = 'p-activator-portal-training-page__enroll-card';
const CLASS_ENROLL_BUTTON = 'js-enroll-btn';

const SELECTOR_WRAPPER = `.${CLASS_WRAPPER}`;
const SELECTOR_ENROLL_BUTTON = `.${CLASS_ENROLL_BUTTON}`;
const SELECTOR_ENROLL_CARD = `.${CLASS_ENROLL_CARD}`;

const CLICK_EVENT = 'click';

const IS_LOCAL = false;

class ActivatorPortalTrainingPage {
	constructor() {
		this._wrapper = SelectorEngine.findOne(SELECTOR_WRAPPER);
		if (!this._wrapper) {
			return;
		}
		this.init();
	}

	init() {
		this.enrollCard = SelectorEngine.findOne(SELECTOR_ENROLL_CARD, this._wrapper);
		this.enrollButton = SelectorEngine.findOne(SELECTOR_ENROLL_BUTTON, this._wrapper);

		this.getRedirectUrl = Manipulator.getDataAttribute(this.enrollCard, 'get-redirect-api');

		EventHandler.on(this.enrollButton, CLICK_EVENT, (event) => {
			event.preventDefault();
			this.fetchRedirectUrl();
		});
	}

	async fetchRedirectUrl() {
		startLoadingAnimation();
		try {
			if (!this.getRedirectUrl) {
				// eslint-disable-next-line no-console
				console.error('Redirect API URL not configured');
				stopLoadingAnimation();
				return;
			}

			const url = this.getRedirectUrl;
			const response = await Request.post(url, {
				local: IS_LOCAL,
				req: {
					apiMode: ApiMode.LtaError
				}
			});

			const { RedirectUrl, redirectUrl, Success, success, error } = response;
			stopLoadingAnimation();

			if (error?.hasError) {
				// eslint-disable-next-line no-console
				console.error('Error fetching redirect URL:', error?.message || error?.errorMessage);
				return;
			}

			if ((Success || success) && (RedirectUrl || redirectUrl)) {
				const targetUrl = RedirectUrl || redirectUrl;

				window.location.href = targetUrl;
			} else {
				// eslint-disable-next-line no-console
				console.error('No redirect URL received from the API');
				window.location.reload();
			}
		} catch (error) {
			stopLoadingAnimation();
			// eslint-disable-next-line no-console
			console.error('Error during redirect URL fetch:', error);
		}
	}
}

const globalActivatorPortalTrainingPage = new ActivatorPortalTrainingPage();
export default globalActivatorPortalTrainingPage;
